import { Component, Prop, Vue } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

import { cloneDeep } from 'lodash'
import SwitchPortal from '@/components/edit/SwitchPortal/index.vue'
import String from '@/components/edit/String/index.vue'

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faTrashAlt)

interface Item {
	label: string
}

@Component({
	components: {
		SwitchPortal,
		String,
	},
})
export default class FieldPortal extends Vue {
	@Prop() placeholder!: string
	@Prop() readonly model!: string[]
	@Prop() type!: string
	@Prop() name!: string

	newModel: any
	triggerArray: boolean[] = [] // array used to force reactivity

	async created() {
		if (Array.isArray(this.model) || typeof this.model === 'object') {
			this.newModel = cloneDeep(this.model)
		} else {
			this.newModel = this.model
		}
	}

	itemRemove(index: number, name: string) {
		this.triggerArray.push(true) // triggering reactivity
		this.newModel.splice(index, 1)
		this.onInput(name, this.newModel)
	}

	itemAdd() {
		this.triggerArray.push(true) // triggering reactivity
		this.newModel.push('')
	}

	onInput(name, value) {
		this.$emit('input', name, value)
	}

	onInputNumber(event) {
		const value = event.target.value
		this.onInput(this.name, value)
	}

	inputItem(index, name, value) {
		Vue.set(this.newModel, index, value)
		this.onInput(name, this.newModel)
	}
}
